import { GoalSortingMode, rootId } from '@griply/types';
import { GoalReorderSectionUpdate, UpdateGoal } from 'shared/types/goal';
import { ID } from 'shared/types/id';

// Applied verbatim: the resolver emits sorting-only parent entries, and re-parenting those makes the focal goal its own parent.
export const resolveRoadmapTimelineReorder = (
  focalGoalId: ID,
  updatedSections: GoalReorderSectionUpdate[],
  updatedGoals: UpdateGoal[],
): UpdateGoal[] => {
  // A sidebar root drop would un-parent the dragged goal out of this
  // subtree — not allowed from the single-goal timeline.
  const unparents = updatedGoals.some((update) => update.ancestorIds === null);
  if (unparents) {
    return [];
  }

  const sectionUpdates = updatedSections
    .filter(({ id }) => id === rootId)
    .map(({ goalSorting }) => ({ id: focalGoalId, goalSorting }));

  // A goal that receives a freshly-dragged child order must switch to Custom
  // sort: getScopedGoalOrder only honors goalSorting when the mode is Custom,
  // so under any other sort the drag is written but re-sorted away on render.
  return [...updatedGoals, ...sectionUpdates].map((update) =>
    update.goalSorting === undefined
      ? update
      : { ...update, goalSortingMode: GoalSortingMode.Custom },
  );
};
